module.exports = __webpack_public_path__ + "static/assets/aabc1df0ebdb0f0f1f681bcd154976c5.svg";